/**
 * 저장분에 이미 쌓인 백슬래시를 걷어낸다.
 *
 * 옛 복원기가 마크다운을 해석하지 못해 turndown 이 매 저장마다 이스케이프를 덧씌웠고,
 * 그 결과 백슬래시가 왕복 1회마다 2배로 늘었다(실측 1 → 2 → 4 → 8). 백슬래시 1개는
 * 사람이 직접 넣은 정상 이스케이프이므로 건드리지 않고, 2개 이상 연달아 구두점 앞에
 * 붙어 있는 것만 오염으로 보고 지운다.
 */
export function normalizeLegacyEscapes(md: string): string {
  return md.replace(/\\{2,}(?=[\\`*_{}[\]()#+\-.!>~|=])/g, '');
}
